<template>
    <div class="pop" @click.self="back">
        <div class="pop-con">
            <samp @click="back" />
            <p>Dear client , the repayment  amount should equal to below extension amount, otherwise system will failed to extend the loan automatically.<br />At the same time, you can also contact our CS for other inquiry.</p>
            <span>Kindly pay attention:<br />1.AUTO extension only work when payment is on or before due date.<br />2.We suggest to Pay in Full the loan to unlock and enable to get higher loan amount  and longer term.</span>
            <div class="con-opt">
                <span>Extension term: </span>
                <b v-text="data.loanTerm +' day'" />
            </div>
            <div class="con-opt">
                <span>Extension amount: </span>
                <b v-text="'PHP '+ data.extendServiceFee" />
            </div>
			<div class="btn_wrap">
				<a @click="Dial">Call CS</a>
				<a @click="extend">GO Extend</a>
			</div>
        </div>
    </div>
</template>
<script>
	import uni from '../assets/js/webview.js'
export default{
    props: ['id','repayChannel','withdrawChannel'],
    data(){
        return {
            orderId: this.id,
            repaymentChannel: this.repayChannel,
            data: {
                loanTerm: '',
                extendServiceFee: '',
                contractNumber: '',
                dueDate: '',
				phone:""
            }
        }
    },
    mounted: function() {
        var self = this;
        self.orderId && self.getExtensionInfo();
		self.phone = this.UTILS.getParam("phone") || "09270023183";	
    },
    methods:{
        //获取逾期信息
        getExtensionInfo(){
            var self = this;
            self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/order/getExtensionInfo', {
                orderId: self.orderId
            }, function(res) {
                self.UTILS.loadGif.hide();
                if(res.code == '0000'){
                    self.data = res.data;
                }else{
                    self.UTILS.logStr(res.message);
                }
            }, 1);
        },

        //展期
        extend(){
            var self = this;
            if(self.data.extendServiceFee > 0){
                self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/order/autoExtension', {
                    orderId: self.orderId
                }, function(res) {
                    self.UTILS.loadGif.hide();
                    if(res.code == '0000'){
                        if(self.repaymentChannel == 1){
                            location.href = './skypay.html?orderId='+ self.orderId +'&extendServiceFee='+ self.data.extendServiceFee +'&contractNumber='+ self.data.contractNumber +'&dueDate='+ self.data.dueDate +'&withdrawChannel='+self.withdrawChannel;
                        }else{
                            location.href = './repayment.html?orderId='+ self.orderId +'&extendServiceFee='+ self.data.extendServiceFee;
                        }
                    }else{
                        self.UTILS.logStr(res.message);
                    }
                }, 1);
            }else{
                self.back();
            }
        },

        back(){
			this.$emit("back")
		},
		Dial(){
			let self = this;
			if(self.UTILS.getEnv()){
				try {
					uni.postMessage({
						data: {
							action: 'call',
							value: self.phone
						}
					});
				} catch (e) {
					console.log(e)
				}
			}
			else{
				location.href ="tel:" + self.phone
			}
		}
    }
}
</script>

<style scoped>
.pop{ width: 100%; height: 100%; background: rgba(0,0,0,0.3); position: fixed; top: 0; left: 0;z-index: 9;}
.pop-con samp{  width: 0.6rem; height: 0.6rem; background: url("~@assets/img/close1.png") no-repeat center; background-size: 0.4rem; position: absolute; right: 0.1rem; top: 0.1rem;}
.pop-con{ width: 6.76rem; height: 8.82rem; padding-top: 0.8rem; background-color: #FFF; border-radius: 0.2rem; position: absolute; top: 50%; left: 50%; margin-top: -4.41rem; margin-left: -3.38rem;}
.pop-con p{ padding: 0 0.3rem; line-height: 0.38rem; text-align: center; font-size: 0.28rem; color: #333;}
.pop-con > span{ padding: 0 0.3rem; line-height: 0.38rem; font-size: 0.26rem; color: #F10202; display: block; margin-top: 0.3rem;}
.con-opt{ height: 0.62rem; margin: 0.3rem 0.4rem 0 0.4rem;}
.con-opt span{ width: 2.6rem; line-height: 0.62rem; font-size: 0.28rem; text-align: right; color: #3D3D3D; float: left; margin-right: 0.16rem;}
.con-opt b{ width: 3.1rem; height: 0.62rem; line-height: 0.62rem; text-align: center; font-size: 0.28rem; font-weight: normal; color: #FFF; background-color: #FF8F1F; border-radius: 0.16rem; float: left;}
.btn_wrap{ height: 0.62rem; margin: 0.3rem 0.4rem 0 0.4rem;}
.btn_wrap a{ width: 2.6rem; height: 0.62rem; line-height: 0.62rem; text-align: center; font-size: 0.32rem; color: #FFF;background-color: #667FFB; border-radius: 0.16rem;}
.btn_wrap a:nth-child(1){ float: left;}
.btn_wrap a:nth-child(2){ float: right;}
</style>
